/*
  "Protect Your Investment" cart cross-sell tracking (PRO-15257)

  Pushes GTM dataLayer events for the cart upsell module in the cart drawer
  (snippets/mini-cart-upsell.liquid) and on the cart page (sections/cart-upsell.liquid):
    - cart_upsell_view           module shown (once per drawer open / once per cart page load)
    - cart_upsell_add            Add clicked on a product in the module
    - cart_upsell_product_click  product image/name clicked through to the PDP (drawer only;
                                 on the cart page those links trigger Add instead)

  Every event carries upsell_source so module adds can be told apart from the
  same products added on a PDP or collection page.
*/
(function() {
  var SOURCE = 'cart_protect_upsell';
  var MODULES = [
    { selector: '.cart__upsell', location: 'cart_drawer' },
    { selector: '.cartpage__upsell', location: 'cart_page' }
  ];

  window.dataLayer = window.dataLayer || [];

  function getModule(el) {
    for (var i = 0; i < MODULES.length; i++) {
      var module = el.closest(MODULES[i].selector);
      if (module) return { el: module, location: MODULES[i].location };
    }
    return null;
  }

  function getItems(moduleEl) {
    return Array.prototype.slice.call(moduleEl.querySelectorAll('[data-upsell-name]'));
  }

  function itemData(itemEl, moduleEl) {
    return {
      item_name: itemEl.dataset.upsellName,
      item_id: itemEl.dataset.productId,
      item_position: getItems(moduleEl).indexOf(itemEl) + 1,
      price: parseFloat(itemEl.dataset.upsellPrice) || 0
    };
  }

  /* GTM merges every push into one data model (arrays included), so clear the
     per-event keys in a separate push first or a view would carry the last
     add's product, and a shorter upsell_items list would keep stale entries */
  var EVENT_KEYS = ['item_name', 'item_id', 'item_position', 'price', 'opens_variant_picker', 'upsell_items', 'upsell_item_count'];

  function push(event, location, data) {
    var reset = {};
    EVENT_KEYS.forEach(function(key) { reset[key] = undefined; });
    window.dataLayer.push(reset);

    var payload = { event: event, upsell_source: SOURCE, upsell_location: location };
    for (var key in data) payload[key] = data[key];
    window.dataLayer.push(payload);
  }

  function pushView(moduleEl, location) {
    var items = getItems(moduleEl);
    if (!items.length) return false;
    push('cart_upsell_view', location, {
      upsell_items: items.map(function(item) { return itemData(item, moduleEl); }),
      upsell_item_count: items.length
    });
    return true;
  }

  /* Clicks: capture phase so theme handlers that stop propagation can't swallow them */
  document.addEventListener('click', function(evt) {
    var module = getModule(evt.target);
    if (!module) return;
    var itemEl = evt.target.closest('[data-upsell-name]');
    if (!itemEl) return;

    var data = itemData(itemEl, module.el);

    var addBtn = evt.target.closest('.grid-product__actions button');
    if (addBtn) {
      data.opens_variant_picker = addBtn.classList.contains('quick-product__btn');
      push('cart_upsell_add', module.location, data);
      return;
    }

    if (module.location === 'cart_drawer' && evt.target.closest('a[href]')) {
      push('cart_upsell_product_click', module.location, data);
    }
  }, true);

  /* Cart drawer view: once per open. The upsell re-renders after cart changes,
     so wait for it to settle and also catch it if it first appears while open. */
  var drawerViewSent = false;
  var drawerTimer = null;

  function isDrawerOpen() {
    return document.documentElement.classList.contains('cart-open');
  }

  function scheduleDrawerView() {
    clearTimeout(drawerTimer);
    drawerTimer = setTimeout(function() {
      if (drawerViewSent || !isDrawerOpen()) return;
      var moduleEl = document.querySelector('[data-cart-upsell] .cart__upsell');
      if (moduleEl && pushView(moduleEl, 'cart_drawer')) drawerViewSent = true;
    }, 800);
  }

  /* Not every opener dispatches CartDrawer:open (the header cart button doesn't),
     so watch the cart-open class on <html> that every open/close toggles */
  var wasOpen = isDrawerOpen();
  if (wasOpen) scheduleDrawerView();

  var drawerUpsell = document.querySelector('[data-cart-upsell]');
  if ('MutationObserver' in window) {
    new MutationObserver(function() {
      var open = isDrawerOpen();
      if (open && !wasOpen) {
        drawerViewSent = false;
        scheduleDrawerView();
      }
      wasOpen = open;
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  if (drawerUpsell && 'MutationObserver' in window) {
    new MutationObserver(function() {
      if (isDrawerOpen() && !drawerViewSent) scheduleDrawerView();
    }).observe(drawerUpsell, { childList: true });
  }

  /* Cart page view: once per page load, when the module scrolls into view */
  var pageModule = document.querySelector('.cartpage__upsell');
  if (pageModule) {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {
          pushView(pageModule, 'cart_page');
          observer.disconnect();
        }
      }, { threshold: 0.3 });
      observer.observe(pageModule);
    } else {
      pushView(pageModule, 'cart_page');
    }
  }
})();
